import type { HitProps } from '@components/algolia/Hit';
import { isGiftCardHit } from '@utils/algolia/isGiftCardHit';

/**
 * Whether a product can be quick added in the given colour: listed, not a
 * gift card, and that colour can be bought online. Callers pass the colour
 * they actually show Quick Add for (the active swatch, or a pinned
 * `variantSku`'s colour via `colourKeyForVariantSku`), so a prefetch and the
 * trigger it warms never disagree. The rollout flag is the caller's to check.
 * Both availability fields aren't populated on every index, so only an
 * explicit `false` hides Quick Add.
 */
export const isQuickAddEligible = (
  product: HitProps,
  colourKey: string
): boolean =>
  product.availableOnPlp !== false &&
  product.variants?.[colourKey]?.availableOnlinePurchase !== false &&
  !isGiftCardHit(product.parentSku);

export default isQuickAddEligible;
